export default __webpack_public_path__ + "static/media/stage_08@2x.f617a662.png";